module.exports = wp["blockEditor"];